// This file is generated by Style Dictionary
const tokens = {
  contentImpactMobile: {
    highlight: {
      fontFamily: "'Inter', 'Inter-Medium'",
      fontSize: '1.25rem',
      letterSpacing: '0px',
      lineHeight: '30px',
      fontWeight: '500',
    },
    medium: {
      fontFamily: "'Inter', 'Inter-Medium'",
      fontSize: '1rem',
      letterSpacing: '0px',
      lineHeight: '24px',
      fontWeight: '500',
    },
  },
  contentImpact: {
    highlight: {
      fontFamily: "'Inter', 'Inter-Medium'",
      fontSize: '1.5rem',
      letterSpacing: '0px',
      lineHeight: '36px',
      fontWeight: '500',
    },
    medium: {
      fontFamily: "'Inter', 'Inter-Medium'",
      fontSize: '1.125rem',
      letterSpacing: '0px',
      lineHeight: '27px',
      fontWeight: '500',
    },
  },
  content: {
    body: {
      fontFamily: "'Inter'",
      fontSize: '1rem',
      letterSpacing: '0px',
      lineHeight: '26px',
      fontWeight: '400',
    },
    bodySmall: {
      fontFamily: "'Inter'",
      fontSize: '0.875rem',
      letterSpacing: '0px',
      lineHeight: '22px',
      fontWeight: '400',
    },
    caption: {
      fontFamily: "'Inter'",
      fontSize: '0.75rem',
      letterSpacing: '0px',
      lineHeight: '18px',
      fontWeight: '400',
    },
    overline: {
      fontFamily: "'Inter', 'Inter-Medium'",
      fontSize: '0.75rem',
      letterSpacing: '0px',
      lineHeight: '18px',
      fontWeight: '500',
      textTransform: 'uppercase',
    },
    subheading: {
      fontFamily: "'Inter', 'Inter-Medium'",
      fontSize: '1rem',
      letterSpacing: '0px',
      lineHeight: '26px',
      fontWeight: '500',
    },
    subheadingSmall: {
      fontFamily: "'Inter', 'Inter-Medium'",
      fontSize: '0.875rem',
      letterSpacing: '0px',
      lineHeight: '22px',
      fontWeight: '500',
    },
  },
  action: {
    button: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '1rem',
      letterSpacing: '0px',
      lineHeight: '24px',
      fontWeight: '700',
    },
    hyperlink: {
      fontFamily: "'Inter', 'Inter-Medium'",
      fontSize: '1rem',
      letterSpacing: '0px',
      lineHeight: '26px',
      fontWeight: '500',
      textDecoration: 'underline',
    },
    hyperlinkSmall: {
      fontFamily: "'Inter', 'Inter-Medium'",
      fontSize: '0.875rem',
      letterSpacing: '0px',
      lineHeight: '22px',
      fontWeight: '500',
      textDecoration: 'underline',
    },
    hyperlinkLarge: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '1rem',
      letterSpacing: '0px',
      lineHeight: '24px',
      fontWeight: '700',
    },
  },
  form: {
    checkbox: {
      fontFamily: "'Inter'",
      fontSize: '1rem',
      letterSpacing: '0px',
      lineHeight: '24px',
      fontWeight: '400',
    },
    chip: {
      fontFamily: "'Inter', 'Inter-Medium'",
      fontSize: '0.875rem',
      letterSpacing: '0px',
      lineHeight: '22px',
      fontWeight: '500',
    },
    errorMessage: {
      fontFamily: "'Inter'",
      fontSize: '0.875rem',
      letterSpacing: '0px',
      lineHeight: '22px',
      fontWeight: '400',
    },
    helper: {
      fontFamily: "'Inter'",
      fontSize: '0.875rem',
      letterSpacing: '0px',
      lineHeight: '22px',
      fontWeight: '400',
    },
    input: {
      fontFamily: "'Inter'",
      fontSize: '1rem',
      letterSpacing: '0px',
      lineHeight: '24px',
      fontWeight: '400',
    },
    label: {
      fontFamily: "'Inter', 'Inter-Medium'",
      fontSize: '0.875rem',
      letterSpacing: '0px',
      lineHeight: '22px',
      fontWeight: '500',
    },
    radioButton: {
      fontFamily: "'Inter'",
      fontSize: '1rem',
      letterSpacing: '0px',
      lineHeight: '24px',
      fontWeight: '400',
    },
    checkboxSingle: {
      fontFamily: "'Inter'",
      fontSize: '0.875rem',
      letterSpacing: '0px',
      lineHeight: '22px',
      fontWeight: '400',
    },
  },
  titleMobile: {
    h1: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '1.625rem',
      letterSpacing: '0px',
      lineHeight: '33px',
      fontWeight: '700',
    },
    h1Impact: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '2.5rem',
      letterSpacing: '0px',
      lineHeight: '50px',
      fontWeight: '700',
    },
    h2: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '1.5rem',
      letterSpacing: '0px',
      lineHeight: '36px',
      fontWeight: '700',
    },
    h3: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '1.25rem',
      letterSpacing: '0px',
      lineHeight: '30px',
      fontWeight: '700',
    },
    h4: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '1.125rem',
      letterSpacing: '0px',
      lineHeight: '27px',
      fontWeight: '700',
    },
    h5: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '1rem',
      letterSpacing: '0px',
      lineHeight: '24px',
      fontWeight: '700',
    },
    h6: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '0.875rem',
      letterSpacing: '0px',
      lineHeight: '22px',
      fontWeight: '700',
    },
  },
  title: {
    h1: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '2.5rem',
      letterSpacing: '0px',
      lineHeight: '50px',
      fontWeight: '700',
    },
    h1Impact: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '3.625rem',
      letterSpacing: '0px',
      lineHeight: '72px',
      fontWeight: '700',
    },
    h2: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '2rem',
      letterSpacing: '0px',
      lineHeight: '48px',
      fontWeight: '700',
    },
    h3: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '1.5rem',
      letterSpacing: '0px',
      lineHeight: '36px',
      fontWeight: '700',
    },
    h4: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '1.25rem',
      letterSpacing: '0px',
      lineHeight: '30px',
      fontWeight: '700',
    },
    h5: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '1.125rem',
      letterSpacing: '0px',
      lineHeight: '27px',
      fontWeight: '700',
    },
    h6: {
      fontFamily: "'Inter', 'Inter-Bold'",
      fontSize: '1rem',
      letterSpacing: '0px',
      lineHeight: '24px',
      fontWeight: '700',
    },
  },
};
export default tokens;
